export const getStructuredDataOnly = (data) => {
  const {
    businessContextAndRiskLandscape,
    applicationArchitectureAndDataIntegration,
    devopsTestAutomationAndDeveloperExperience,
    aiMLLLMConsideration,
    observabilityResilienceSecurityAndScalability,
    qualityCultureGovernanceAndTestDebt,
    dataCentricAndCapabilityAlignedQE
  } = data;

  return {
    businessContextAndRiskLandscape: businessContextAndRiskLandscape || {},
    applicationArchitectureAndDataIntegration: applicationArchitectureAndDataIntegration || {},
    devopsTestAutomationAndDeveloperExperience: devopsTestAutomationAndDeveloperExperience || {},
    aiMLLLMConsideration: aiMLLLMConsideration || {}, 
    observabilityResilienceSecurityAndScalability: observabilityResilienceSecurityAndScalability || {},
    qualityCultureGovernanceAndTestDebt: qualityCultureGovernanceAndTestDebt || {},
    dataCentricAndCapabilityAlignedQE: dataCentricAndCapabilityAlignedQE || {},
  };
};
